import React from "react";
import { useParams } from "react-router-dom";

import PageContent from "2g-page-content";

import ProvozniInformaceEditaceWidget from "b2b/components/provozni-informace-editace-widget";

function ProvozniInformaceEditace() {
  const { id } = useParams();
  return (
    <PageContent>
      <ProvozniInformaceEditaceWidget id={id} />
    </PageContent>
  );
}

export default React.memo(ProvozniInformaceEditace);
